export default __webpack_public_path__ + "static/amsterdam-mobile-8a6baf2a6c7ca3f70816eaf8ebc0cb22.png";